import React, { useContext } from 'react';
import SectionItemText from './SectionItemText';
import { CioAutocompleteContext } from '../CioAutocompleteProvider';
export default function SearchSuggestionItem(props) {
    const { item, displaySearchTermHighlights } = props;
    const { advancedParameters, query, featureToggles } = useContext(CioAutocompleteContext);
    const { featureDisplaySearchSuggestionImages, featureDisplaySearchSuggestionResultCounts } = featureToggles;
    const { displaySearchSuggestionImages = featureDisplaySearchSuggestionImages, displaySearchSuggestionResultCounts = featureDisplaySearchSuggestionResultCounts, } = advancedParameters || {};
    return (React.createElement(React.Fragment, null,
        displaySearchSuggestionImages && item.data?.image_url && (React.createElement("img", { src: item.data?.image_url, alt: item.value, className: 'cio-suggestion-image' })),
        React.createElement("p", { className: 'cio-suggestion-text' },
            React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights })),
        displaySearchSuggestionResultCounts && item.data?.total_num_results && (React.createElement("p", { className: 'cio-suggestion-count' },
            "(",
            item.data?.total_num_results,
            ")"))));
}
